var AKARUCMS = AKARUCMS || {};
